export enum UsersFilterOptions {
  noFilter = 0,
  withProfiles = 1,
  noProfiles = 2,
  admins = 3,
  adminsAndModerators = 4,
  supervisors=5,
}
